import { AfterViewInit, Component, inject, viewChild } from "@angular/core";
import { AsyncSubject } from "rxjs";
import { SearchType } from "../../shared/services/search-storage.service";
import { GenericSearchPageComponent } from "../generic-search-page/generic-search-page.component";
import { QuoteSearchService } from "./quote-search.service";
import { QuoteSearchParameters } from "./types/QuoteSearchParameters";
import { QuoteSearchRow } from "./types/QuoteSearchRow";
import { filterDefinitions } from "./quote-search-filters";
import { IFilterCategoryDef } from "../../shared/interfaces/IFilterDef";
import { LoadingService } from "../../shared/services/loading-overlay/loading-overlay.component";
import { QuoteEditModal } from "../../modals/quote-edit-modal/quote-edit-modal.component";
import { InvoiceEditModal } from "../../modals/invoice-modal/edit/invoice-edit-modal.component";
import { QuoteSearchResultsGridComponent } from "./quote-search-results-grid/quote-search-results-grid.component";

@Component({
  selector: 'quote-search',
  templateUrl: 'quote-search.component.html',
  standalone: true,
  imports: [GenericSearchPageComponent, QuoteSearchResultsGridComponent],
  providers: [LoadingService, QuoteSearchService]
})
export class QuoteSearchComponent implements AfterViewInit {
  private searchService = inject(QuoteSearchService);
  private loadingService = inject(LoadingService);
  private quoteEditModal = inject(QuoteEditModal);
  private invoiceEditModal = inject(InvoiceEditModal);
  protected SearchPageComponent = viewChild.required<GenericSearchPageComponent<QuoteSearchRow, QuoteSearchParameters>>(GenericSearchPageComponent);

  protected filterCategories: IFilterCategoryDef<QuoteSearchParameters>[] = filterDefinitions.filterCategories;
  protected searchHistoryType = SearchType.Quotes;
  protected searchFn = (params: QuoteSearchParameters) => this.searchService.SearchQuotes(params);
  protected editFn = (row: QuoteSearchRow) => {
    const retVal = new AsyncSubject<boolean>();
    this.quoteEditModal.ShowModal({
      VendorId: Number(row.VendorId),
      QuoteId: Number(row.QuoteId)
    })
      .subscribe((result) => {
        // Check if result exists (user didn't cancel)
        if (result) {
          retVal.next(result.QuoteId !== undefined);

          if (result.InvoiceIdToDisplay !== undefined) {
            this.invoiceEditModal.ShowModal({
              InvoiceId: result.InvoiceIdToDisplay
            }).subscribe(() => {
              retVal.complete();
            });
          } else {
            retVal.complete();
          }
        } else {
          // User cancelled, no changes made
          retVal.next(false);
          retVal.complete();
        }
      });
    return retVal.asObservable();
  };

  ngAfterViewInit() {
    const loadRef = this.loadingService.StartWaiting("Loading Options...");
    this.searchService.GetDropdowns().subscribe((response) => {
      console.log("response", response);
      filterDefinitions.mapFiltersFromApi(response);
      this.SearchPageComponent().InitializeFilters();
      loadRef.Stop();
    });
  }
}
